import { computed } from "@vue/composition-api";
import store from "@/store";

export default () => {
  const userData = computed(() => {
    return {
      userId: store.state.auth.user?.id,
      clientId: store.state.auth.client?.id,
      firstName: store.state.auth.user?.firstName,
      lastName: store.state.auth.user?.lastName,
      email: store.state.auth.user?.email,
    };
  });

  const orderDataFormat = (packageCreate, coupon, discount) => ({
    id: packageCreate?.order?.id,
    affiliation: "Portal Checkout",
    revenue: packageCreate?.order?.total,
    coupon: coupon,
    discount: discount,
  });

  const cartData = computed(() => {
    // price according to term
    const pack = store.getters["appPackages/getAppPackage"](
      store.state.checkout.packageId,
      store.state.checkout.appId
    );
    const price = store.getters["checkout/getPackageFee"](pack);
    // coupon (if one was provided)
    const coupon = store.state.checkout.couponCode;
    // cart data to be used for analytics
    return {
      brand: "Nexcess",
      name: pack.name,
      id: pack.id,
      price: price,
      quantity: 1,
      coupon,
    };
  });

  return { cartData, userData, orderDataFormat };
};
